import { BaseModel } from './base';

export class ProductCategory extends BaseModel {
  idProductCategory!: number;
  name!: string;
  listOrder?: number;

  override objectID(): string | null {
    return Number(this.idProductCategory) > 0
      ? this.idProductCategory.toString()
      : null;
  }
}
